<template>
  <b-nav-item-dropdown
    class="dropdown-theme-settings mr-25"
    menu-class="dropdown-menu-media mt-50 w-auto p-2"
    title="Настройки интерфейса"
    right
  >
    <template #button-content>
      <feather-icon
        badge-classes="bg-danger"
        class="text-body"
        icon="SettingsIcon"
        size="21"
      />
    </template>
    <li class="dropdown-menu-header mb-1">
      <div class="d-flex align-items-center justify-content-center mb-2">
        <feather-icon
          badge-classes="bg-danger"
          class="text-body mr-1"
          icon="SettingsIcon"
          size="21"
        />
        <p class="text-center mb-0">Настройки интерфейса</p>
      </div>
    </li>
    <li class="dropdown-item">
      <div class="d-flex align-items-center">
        <layout-type-switcher />
      </div>
    </li>
    <li class="dropdown-item">
      <dark-toggler />
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem
} from 'bootstrap-vue'
import LayoutTypeSwitcher from '@/core/layouts/components/app-navbar/components/LayoutTypeSwitcher';
import DarkToggler from '@/core/layouts/components/app-navbar/components/DarkToggler';
export default {
  name: 'ThemeSettings',
  components: {
    DarkToggler,
    LayoutTypeSwitcher,
    BNavItemDropdown, BDropdownItem
  }
}
</script>

<style lang='scss'>

@import '@/assets/scss/style';

.dark-layout {
  .dropdown-menu-header {
    color: $theme-dark-body-color;
    border-bottom: 1px solid $theme-dark-border-color !important;
  }
}
</style>
